module.exports = __webpack_public_path__ + "static/media/Heebo-Regular.3f5fef64.ttf";